import styled from 'styled-components';

const Wrapper = styled.a`
  width: calc(100%);
  -webkit-font-smoothing: antialiased;
  -webkit-touch-callout: none;
  display: flex;
  flex-direction: column;
  padding-left: 10px;
  padding-right: 10px;
  padding-block: 10px;
  margin-bottom: 10px;
  background: ${props => props.active ? "#3C3F45" : "#26292D"};
  border-radius: 8px;
  transition: 0.3s;
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none;
  position: relative;

  &:hover{
      background: #3C3F45;
  }
  ${props => props.active && "border-left: 5px solid #FBAE1A;"}
`;

export default Wrapper;